"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AgencyQualityEvaluationDTO_1 = require("../../model/dto/AgencyQualityEvaluationDTO");

var AgencyQualityEvaluationDTOConverter_1 = require("./AgencyQualityEvaluationDTOConverter");
/**
 * Implementation of AgencyQualityEvaluationDTOConverter
 *
 * @author VBr
 */


var AgencyQualityEvaluationDTOConverterImpl =
/*#__PURE__*/
function (_AgencyQualityEvaluat) {
  _inherits(AgencyQualityEvaluationDTOConverterImpl, _AgencyQualityEvaluat);

  function AgencyQualityEvaluationDTOConverterImpl() {
    _classCallCheck(this, AgencyQualityEvaluationDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(AgencyQualityEvaluationDTOConverterImpl).apply(this, arguments));
  }

  _createClass(AgencyQualityEvaluationDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new AgencyQualityEvaluationDTO_1.AgencyQualityEvaluationDTO(source.dataUploadId, source.competitorSiteId, source.outliers, source.totalCollectedProducts, source.totalCollectedPrices, conversions.toDate(source.date));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        dataUploadId: source.dataUploadId,
        competitorSiteId: source.competitorSiteId,
        outliers: source.outliers,
        totalCollectedProducts: source.totalCollectedProducts,
        totalCollectedPrices: source.totalCollectedPrices,
        date: conversions.fromDate(source.date)
      });
      return result;
    }
  }]);

  return AgencyQualityEvaluationDTOConverterImpl;
}(AgencyQualityEvaluationDTOConverter_1.AgencyQualityEvaluationDTOConverter);

exports.AgencyQualityEvaluationDTOConverterImpl = AgencyQualityEvaluationDTOConverterImpl;